import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function HtmlImportGuide({ open, onClose, onChooseFile, kind }) {
    const isLaytime = kind === "laytime";
    const formName = isLaytime ? "Laytime Statement" : "Statement of Facts";
    const formPath = isLaytime ? "/htmlForms/laytime.html" : "/htmlForms/sof.html";

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" aria-labelledby="html-import-title">
            <DialogTitle id="html-import-title" className="font-family">Import {formName} from HTML</DialogTitle>
            <DialogContent>
                <p className="text-[12px] text-slate-700 mb-3">
                    Upload a completed {formName} offline form to fill this panel.
                </p>
                <div className="border border-slate-200 bg-slate-50 px-3 py-3 text-[12px] text-slate-800">
                    <div className="font-semibold mb-2">Prepare the HTML file</div>
                    <ol className="list-decimal pl-5 space-y-2">
                        <li>
                            Download the blank <a href={formPath} download className="text-[#313C4C] font-semibold underline">{formName} offline form</a>.
                        </li>
                        <li>Open that file in your browser and fill in the form.</li>
                        <li>Choose <strong>Download HTML</strong> inside the form, then select the saved .html file below.</li>
                    </ol>
                </div>
                <button type="button" onClick={onChooseFile} className="mt-3 w-full border border-dashed border-slate-400 bg-white px-3 py-5 text-[12px] font-semibold text-[#313C4C] hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#313C4C]">
                    Choose completed HTML file
                    <span className="block mt-1 font-medium text-slate-600">.html or .htm</span>
                </button>
            </DialogContent>
            <DialogActions><Button onClick={onClose} color="primary">Cancel</Button></DialogActions>
        </Dialog>
    );
}
